module.exports = __webpack_public_path__ + "static/media/kids_30.62eaec3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_30.jpg
// module id = 5886
// module chunks = 0